import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { Typography, useMediaQuery,Tooltip } from "@mui/material";
import { setCGState } from "../customerGroupSetupSlice";
import { useDispatch, useSelector } from "react-redux";

const addBtnText = "Add >";
const addAllBtnText = "Add All >>";
const remBtnText = "< Remove";
const remAllBtnText = "<< Remove All";

function not(a, b) {
   return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
   return a.filter((value) => b.indexOf(value) !== -1);
}

export default function CreateTransferList({
   leftList,
   rightList,
   leftState,
   rightState,
}) {
   const cgState = useSelector((store) => store.customerGroupSetup);
   const { selCustomers, createFromDate, createToDate, createIndDateUpdated, is_customer_refresh, is_refresh } =
      cgState;

   const [checked, setChecked] = useState([]);
   const [left, setLeft] = useState([]);
   const [right, setRight] = useState([]);
   const [countLeft, setCountLeft] = useState(0);
   const [countRight, setCountRight] = useState(0);
   const [selectionStart, setSelectionStart] = useState(null);
   const [startIndex, setStartIndex] = useState(null);
   const leftChecked = intersection(checked, left);
   const rightChecked = intersection(checked, right);
   const [isLeftAllSelected, setIsLeftAllSelected] = useState(false);
	const [isRightAllSelected, setIsRightAllSelected] = useState(false);

   const dispatch = useDispatch();

   const isTab = useMediaQuery("(max-width: 800px)");

   useEffect(() => {
      if (leftList?.length >= 0) {
         setLeft(leftList);
      }
      if (rightList?.length >= 0) {
         setRight(rightList);
      }
   }, [leftList, rightList]);

   useEffect(() => {
      setCountLeft(left.length);
      setCountRight(right.length);
   }, [left, right]);

   useEffect(()=>{
		if(is_customer_refresh){
			dispatch(setCGState("is_customer_refresh", false));
			setIsLeftAllSelected(false);
		}
	}, [is_customer_refresh]);

   useEffect(()=>{
		if(is_refresh){
			dispatch(setCGState("is_refresh", false));
			setIsLeftAllSelected(false);
         setIsRightAllSelected(false);
		}
	}, [is_refresh]);

   const handleToggle = (event, index, value, side) => {
      if (event.shiftKey && startIndex !== null) {
         const start = Math.min(startIndex, index);
         const end = Math.max(startIndex, index);
         let a = [];
         if (side === "left") {
            a = JSON.parse(JSON.stringify(left));
         } else {
            a = JSON.parse(JSON.stringify(right));
         }
         const newSelectedItems = a.slice(start, end + 1);
         console.log(newSelectedItems);

         const newChecked = [];
         for (let i = 0; i < newSelectedItems.length; i++) {
            const currentIndex = newChecked.findIndex(
               (item) => getItemId(item) === getItemId(newSelectedItems[i])
            );
            let item = [];
            if (side === "left") {
               item = left.find(
                  (item) => getItemId(item) === getItemId(newSelectedItems[i])
               );
            } else {
               item = right.find(
                  (item) => getItemId(item) === getItemId(newSelectedItems[i])
               );
            }

            if (currentIndex === -1) {
               newChecked.push(item);
            } else {
               newChecked.splice(currentIndex, 1);
            }
         }
         setChecked(newChecked);
      } else {
         const currentIndex = checked.indexOf(value);
         console.log(event);
         const newChecked = [...checked];

         if (currentIndex === -1) {
            newChecked.push(value);
            setStartIndex(index);
         } else {
            newChecked.splice(currentIndex, 1);
            setStartIndex(null);
         }

         setChecked(newChecked);
      }
   };
   const handleMouseDown = (e, index) => {
      e.preventDefault();
      setSelectionStart(index);
   };

   const handleMouseMove = (e, side, index) => {
      if (selectionStart !== null && e.shiftKey) {
         const start = Math.min(selectionStart, index);
         const end = Math.max(selectionStart, index);
         let a = [];
         if (side === "left") {
            a = JSON.parse(JSON.stringify(left));
         } else {
            a = JSON.parse(JSON.stringify(right));
         }
         const newSelectedItems = a.slice(start, end + 1);
         console.log(newSelectedItems);
         if (newSelectedItems.length > 0 && newSelectedItems.length < 10) {
            const newChecked = [];
            for (let i = 0; i < newSelectedItems.length; i++) {
               const currentIndex = newChecked.findIndex(
                  (item) => getItemId(item) === getItemId(newSelectedItems[i])
               );
               let item = [];
               if (side === "left") {
                  item = left.find(
                     (item) =>
                        getItemId(item) === getItemId(newSelectedItems[i])
                  );
               } else {
                  item = right.find(
                     (item) =>
                        getItemId(item) === getItemId(newSelectedItems[i])
                  );
               }
               if (currentIndex === -1) {
                  newChecked.push(item);
               } else {
                  newChecked.splice(currentIndex, 1);
               }
            }
            setChecked(newChecked);
         }
      }
   };
   const handleMouseUp = () => {
      setSelectionStart(null);
   };
   const handleDoubleClick = (item, side) => {
      if (side == "left") {
         dispatch(setCGState(rightState, right.concat(item)));
         let leftlist = JSON.parse(JSON.stringify(left));
         for (let i = 0; i < leftlist.length; i++) {
            if (getItemId(leftlist[i]) === getItemId(item)) {
               leftlist.splice(i, 1);
            }
         }
         leftlist = leftlist.filter((x) => getItemId(x) != getItemId(item));
         dispatch(setCGState(leftState, leftlist));
         setRight(right.concat(item));
         setLeft(leftlist);
         let checkedlist = JSON.parse(JSON.stringify(checked));
         checkedlist = checkedlist.filter(
            (x) => getItemId(x) != getItemId(item)
         );
         setChecked(checkedlist);
      }
      if (side == "right") {
         dispatch(setCGState(leftState, left.concat(item)));
         let rightlist = JSON.parse(JSON.stringify(right));
         // for(let i = 0; i< rightlist.length; i++){
         // 	if(getItemId(rightlist[i]) === getItemId(item)){
         // 		rightlist.splice(i,1);
         // 	}
         // }
         rightlist = rightlist.filter((x) => getItemId(x) != getItemId(item));
         dispatch(setCGState(rightState, rightlist));
         setLeft(left.concat(item));
         setRight(rightlist);
         let checkedlist = JSON.parse(JSON.stringify(checked));
         checkedlist = checkedlist.filter(
            (x) => getItemId(x) != getItemId(item)
         );
         setChecked(checkedlist);
      }
   };

   function updateCustomerDates(list) {
      const updated = list.map((item) => {
         return {
            ...item,
            effectiveStartDate: createFromDate,
            effectiveEndDate: createToDate,
         };
      });
      return updated;
   }

   const handleAllRight = () => {
      setIsLeftAllSelected(false);
      setIsRightAllSelected(false);
      let tempRight = right.concat(left);
      tempRight = updateCustomerDates(tempRight);
      setRight(tempRight);
      setLeft([]);

      dispatch(setCGState(rightState, tempRight));
      dispatch(setCGState(leftState, []));
   };

   const handleCheckedRight = () => {
      setIsLeftAllSelected(false);
      setIsRightAllSelected(false);
      let updatedLeftChecked = updateCustomerDates(leftChecked);
      let tempRight = right.concat(updatedLeftChecked);
      const tempLeft = not(left, leftChecked);

      setRight(tempRight);
      setLeft(tempLeft);
      setChecked(not(checked, leftChecked));

      dispatch(setCGState(rightState, tempRight));
      dispatch(setCGState(leftState, tempLeft));
   };

   const handleCheckedLeft = () => {
      setIsLeftAllSelected(false);
      setIsRightAllSelected(false);
      const tempLeft = left.concat(rightChecked);
      const tempRight = not(right, rightChecked);

      setLeft(tempLeft);
      setRight(tempRight);
      setChecked(not(checked, rightChecked));

      dispatch(setCGState(leftState, tempLeft));
      dispatch(setCGState(rightState, tempRight));
   };

   const handleAllLeft = () => {
      setIsLeftAllSelected(false);
      setIsRightAllSelected(false);
      const tempLeft = left.concat(right);
      setLeft(tempLeft);
      setRight([]);

      dispatch(setCGState(leftState, tempLeft));
      dispatch(setCGState(rightState, []));
   };
   const getItemId = (item) => {
      if (item.hasOwnProperty("customerID")) {
         return item.customerID;
      } else if (item.hasOwnProperty("id")) {
         return item.id;
      }
   };

   const getItemText =(item)=>{
      if (item.hasOwnProperty("name")) {
         return (
           item.name +
           (item["parentName"] == undefined || item["type"] == "CG"
             ? ""
             : item["parentName"].indexOf(",") > -1
             ? " ( * )"
             : " (" + item["parentName"] + " )")
         );
       }
       else if (item.hasOwnProperty("customerGroupName")) {
         return item.customerGroupName;
       }
       else if (item.hasOwnProperty("customerName")) {
         return (
           item.customerName +
           (item["parentName"] == undefined
             ? ""
             : item["parentName"].indexOf(",") > -1
             ? " ( * )"
             : " (" + item["parentName"] + " )")
         );
       }
   }   

   const getItemTextForToolTip = (item) => {
      if (item.hasOwnProperty("name")) {
          return item.name + (item['parentName'] == undefined || item['type']=='CG' ? '' : ' ('+ item['parentName'] + ' )' );;
      } else if (item.hasOwnProperty("customerGroupName")) {
          return item.customerGroupName;
      } else if (item.hasOwnProperty("customerName")) {
          return item.customerName + (item['parentName'] == undefined ? '' : ' ('+ item['parentName'] + ' )' );
      }
  };

   function sortbyName(items, side) {
      let list = items.slice();
      list.sort((first, second) => {
         if (first.customerName < second.customerName) return -1;
         if (first.customerName > second.customerName) return 1;
         return 0;
      });
      if (side === "left") {
         dispatch(setCGState("customers", list));
      } else {
         dispatch(setCGState("selCustomers", list));
      }
   }

   function sortbyNumber(items, side) {
      let list = items.slice();
      list.sort((first, second) => {
         if (first.sapCustomerNumber < second.sapCustomerNumber) return -1;
         if (first.sapCustomerNumber > second.sapCustomerNumber) return 1;
         return 0;
      });
      if (side === "left") {
         dispatch(setCGState("customers", list));
      } else {
         dispatch(setCGState("selCustomers", list));
      }
   }

   const handleSelectAll = (items, side, isSelect) => {
		if(items?.length > 0){
			if(isSelect){
				setChecked(items);
			}else{
				setChecked([]);
			}
			if (side === "left") {
				setIsLeftAllSelected(isSelect);
				setIsRightAllSelected(false);
			} else{
				setIsRightAllSelected(isSelect);
				setIsLeftAllSelected(false);
			}
		}
 	}

   const customList = (items, count, side) => (
      <>
         {side === "right" ? (
            <Typography variant="subtitle1">Customer to be assigned</Typography>
         ) : null}
         {side === "left" ? (
            <Typography variant="subtitle1">Search result</Typography>
         ) : null}
         <Typography
            variant="subtitle2"
            sx={{ cursor: "pointer" }}
            onClick={() => sortbyName(items, side)}  display="inline"
         >
            Sort by Name | 
         </Typography>
         <Typography
            variant="subtitle2"
            sx={{ cursor: "pointer" }}
            onClick={() => sortbyNumber(items, side)}  display="inline"
         >
            Sort by Number
         </Typography>
         <Typography variant="subtitle2">Count: {count}</Typography>
         {side === "left" && <Typography sx={{ cursor: "pointer" }} variant="subtitle2" onClick={() => handleSelectAll(items, side, !isLeftAllSelected)} >
         {isLeftAllSelected && items?.length > 0 ? "Unselect All" : "Select All"}
         </Typography>}
         {side === "right" && <Typography sx={{ cursor: "pointer" }} variant="subtitle2" onClick={() => handleSelectAll(items, side, !isRightAllSelected)} >
         {isRightAllSelected && items?.length > 0 ? "Unselect All" : "Select All"}
         </Typography>}
         <Paper
            sx={{
               width: isTab ? "30vw" : "32vw",
               height: 280,
               overflow: "auto",
            }}
         >
            <List dense component="div" role="list">
               {items.map((customer, index) => {
                  const labelId = `transfer-list-item-${customer.customerID}-label`;

                  return (
                     <ListItem
                        key={index}
                        role="listitem"
                        button
                        selected={checked.indexOf(customer) !== -1}
                        style={{
                           backgroundColor: checked.includes(customer)
                              ? "#f2f1ed"
                              : "",
                        }}
                        onClick={(event) =>
                           handleToggle(event, index, customer, side)
                        }
                        onDoubleClick={() => handleDoubleClick(customer, side)}
                        onMouseDown={(e) => handleMouseDown(e, index)}
                        onMouseMove={(e) => handleMouseMove(e, side, index)}
                        onMouseUp={handleMouseUp}
                     >
                        <ListItemIcon>
                           <Checkbox
                              checked={checked.indexOf(customer) !== -1}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{
                                 "aria-labelledby": labelId,
                              }}
                           />
                        </ListItemIcon>
                        <Tooltip
                           title={getItemTextForToolTip(items[index])}
                           sx={{
                              "& .MuiTooltip-tooltip": {
                              fontSize: "1rem",
                              padding: "10px 20px",
                              },
                           }}
                        >                       
                        <ListItemText
                           disableTypography
                           id={labelId}
                           primary={
                              <Typography
                                 variant="p16w400"
                                 sx={{
                                    color:
                                       customer.stqColor === "Y"
                                          ? "lightBlue.main"
                                          : customer.active === "Y"
                                          ? "black.main"
                                          : "red.main",
                                 }}
                              >
                                 {getItemText(customer)}
                              </Typography>
                           }
                        />
                        </Tooltip>
                     </ListItem>
                  );
               })}
            </List>
         </Paper>
      </>
   );

   return (
      <Grid
         container
         spacing={2}
         justifyContent="space-between"
         alignItems="center"
      >
         <Grid item>{customList(left, countLeft, "left")}</Grid>
         <Grid item>
            <Grid container direction="column" alignItems="center">
               <Button
                  sx={{ my: 0.5 }}
                  variant="outlined"
                  size="small"
                  onClick={handleAllRight}
                  disabled={left.length === 0}
                  aria-label="move all right"
               >
                  {addAllBtnText}
               </Button>
               <Button
                  sx={{ my: 0.5 }}
                  variant="outlined"
                  size="small"
                  onClick={handleCheckedRight}
                  disabled={leftChecked.length === 0}
                  aria-label="move selected right"
               >
                  {addBtnText}
               </Button>
               <Button
                  sx={{ my: 0.5 }}
                  variant="outlined"
                  size="small"
                  onClick={handleCheckedLeft}
                  disabled={rightChecked.length === 0}
                  aria-label="move selected left"
               >
                  {remBtnText}
               </Button>
               <Button
                  sx={{ my: 0.5 }}
                  variant="outlined"
                  size="small"
                  onClick={handleAllLeft}
                  disabled={right.length === 0}
                  aria-label="move all left"
               >
                  {remAllBtnText}
               </Button>
            </Grid>
         </Grid>
         <Grid item>{customList(right, countRight, "right")}</Grid>
      </Grid>
   );
}
